/**
 * 악덕알리미 회원유형 안내 ($j.Pages.Devil.NotAllowed / body data-page-name="NotAllowed")
 *
 * 발주자·업체발주자가 로그인하면 devilAuth 의 회원유형 게이트가 /b/not-allowed 로 보낸다. 할 수 있는 일은 로그아웃뿐.
 * 로그아웃 순서는 Settings._doLogout 과 같다 — 앱에 통지(토큰 정리) → /b/logout 으로 교체 이동(히스토리 누적 방지).
 */
export default class NotAllowed {
    initialize() {
        $('#na-logout').on('click', () => this.onClickLogout());
    }

    onClickLogout() {
        if (window.$j && $j.F && $j.F.App && typeof $j.F.App.logout === 'function') {
            $j.F.App.logout();
        }
        setTimeout(() => location.replace('/b/logout'), 300);
    }
}
